import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, ProgressBar } from '../../components/ui';
import { motion } from 'framer-motion';
import beforeImage from '../../assets/onboarding/before.png';
import afterImage from '../../assets/onboarding/after.png';

const BEFORE_ITEMS = [
  'No clear plan',
  'Inconsistent routines',
  'Low confidence',
];

const AFTER_ITEMS = [
  'Clear structure',
  'Daily momentum',
  'Noticeable improvement',
];

export function ComparisonScreen() {
  const navigate = useNavigate();
  const { nextStep } = useStore();

  const handleContinue = () => {
    nextStep();
    navigate('/onboarding/trajectory');
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={14} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-8">The difference is clear.</h1>

        <div className="flex-1 grid grid-cols-2 gap-3 items-start">
          {/* Before Card */}
          <motion.div
            className="flex flex-col p-3 rounded-3xl bg-surface border border-default"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="w-full aspect-[4/5] rounded-2xl bg-black/40 flex items-center justify-center overflow-hidden mb-3">
              <img
                src={beforeImage}
                alt="Before"
                className="w-full h-full object-cover"
              />
            </div>
            <h2 className="text-lg font-semibold text-secondary mb-2">Before</h2>
            <ul className="space-y-2">
              {BEFORE_ITEMS.map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-secondary">
                  <svg className="w-5 h-5 text-red-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

          {/* After Card */}
          <motion.div
            className="flex flex-col p-3 rounded-3xl border-2"
            style={{
              borderColor: 'var(--color-accent)',
              background: 'rgba(212, 175, 55, 0.05)',
            }}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <div className="w-full aspect-[4/5] rounded-2xl bg-black/40 flex items-center justify-center overflow-hidden mb-3">
              <img
                src={afterImage}
                alt="After"
                className="w-full h-full object-cover"
              />
            </div>
            <h2 className="text-lg font-semibold text-accent mb-2">After</h2>
            <ul className="space-y-2">
              {AFTER_ITEMS.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-accent flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>

      <Button onClick={handleContinue} className="mt-8">
        Continue
      </Button>
    </div>
  );
}
